const getters = {
  version: state => state.user.version,
  openId: state => state.user.openId
}
export default getters
